export default {
    loading: false,
    user: {
        user: undefined,
        originalUser: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    password: {
        password: '',
        newPassword: '',
        retypePassword: '',
        loading: false,
        error: false,
        noContent: false
    },
    activity: {
        page: 1,
        limit: 5,
        limits: [5,10,20],
        loading: false,
        error: false,
        noContent: false,
        items: undefined
    },
    notifications: {
        editMode: false,
        loading: false,
        error: false,
        noContent: false,
        item: undefined,
        originalItem: undefined
    },
    tips: [
        {
            title: 'tips.accountPage.information.title',
            body: 'tips.accountPage.information.body'
        },
        {
            title: 'tips.accountPage.password.title',
            body: 'tips.accountPage.password.body'
        },
        {
            title: 'tips.accountPage.notifications.title',
            body: 'tips.accountPage.notifications.body'
        },
        {
            title: 'tips.accountPage.activity.title',
            body: 'tips.accountPage.activity.body'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/store/modules/account/state.js